
export default function Features() {
  return (
    <section id="features" className="py-32 bg-[#F5F3FF]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-3 h-3 bg-purple-600 rotate-45"></div>
            <span className="text-xs uppercase tracking-wider text-purple-600 font-medium">Features</span>
          </div>
          <h2 className="text-5xl font-bold text-[#4C1D95]">Why Choose Our Applications</h2>
        </div>

        <div className="grid grid-cols-3 gap-5">
          <div className="bg-[#E9E7F0] rounded-3xl p-10 flex flex-col justify-between min-h-[320px]">
            <div>
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6">
                <i className="ri-apple-fill text-purple-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#4C1D95] mb-4">Native iOS Development</h3>
            </div>
            <p className="text-gray-700 text-base leading-relaxed">
              Built specifically for iOS using native technologies, ensuring optimal performance, seamless integration, and the best user experience possible.
            </p>
          </div>

          <div className="bg-[#E9E7F0] rounded-3xl p-10 flex flex-col justify-between min-h-[320px]">
            <div>
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-fill text-purple-600 text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#4C1D95] mb-4">Enhanced Security</h3>
            </div>
            <p className="text-gray-700 text-base leading-relaxed">
              Advanced encryption and security protocols protect your data and privacy, giving you peace of mind while using our applications.
            </p>
          </div>

          <div className="relative rounded-3xl overflow-hidden min-h-[320px]">
            <img 
              src="https://public.readdy.ai/ai/img_res/db69095fc55cbe2579ffe3d324f374d5.jpg" 
              alt="User Experience" 
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-0 left-0 right-0 h-2/5 bg-gradient-to-t from-[#4C1D95] to-transparent p-10 flex flex-col justify-end">
              <h3 className="text-2xl font-bold text-white mb-2">User Experience</h3>
              <p className="text-white/90 text-sm">Intuitive design focused on simplicity</p>
            </div>
          </div>

          <div className="col-span-2 relative rounded-3xl overflow-hidden min-h-[280px]">
            <img 
              src="https://readdy.ai/api/search-image?query=Modern%20iOS%20application%20interface%20showing%20performance%20metrics%20and%20optimization%20features%2C%20purple%20gradient%20overlay%20at%20bottom%20left%2C%20sleek%20dashboard%20design%2C%20professional%20tech%20photography&width=1000&height=560&seq=sylpa-feature-perf&orientation=landscape" 
              alt="Performance" 
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-0 left-0 w-3/5 h-full bg-gradient-to-r from-[#4C1D95] to-transparent p-10 flex flex-col justify-end">
              <h3 className="text-4xl font-bold text-white mb-2">Performance</h3>
              <p className="text-white/90 text-base mb-3">Optimized</p>
              <p className="text-white/80 text-sm leading-relaxed max-w-md">
                Lightning-fast performance with minimal battery consumption, ensuring your device runs smoothly throughout the day.
              </p>
            </div>
          </div>

          <div className="bg-[#E9E7F0] rounded-3xl p-10 flex flex-col justify-between min-h-[280px]">
            <div className="mb-6">
              <i className="ri-double-quotes-l text-purple-600 text-4xl"></i>
            </div>
            <p className="text-gray-700 text-base leading-relaxed mb-6">
              Regular updates with new features and improvements based on user feedback and the latest iOS capabilities.
            </p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center">
                <i className="ri-refresh-line text-white text-lg"></i>
              </div>
              <span className="text-sm font-medium text-[#4C1D95]">Continuous Updates</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
